import React, { useState, useLayoutEffect } from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import AnnounceService from '@/services/Announce.service';
import { useSnackbar } from 'notistack';
import Announce from '@/types/Announce.type';
import { Department, Departments } from '@/types/Department.type';
import { Messages } from '@/common/constants';
import { Box, FormControl, Grid, IconButton, InputLabel, MenuItem } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import PageTitle from '@/components/common/PageTitle';
import ConfirmDialog from '@/components/common/ConfirmDialog';
import Loading from '@/components/common/Loading';
import DepartmentService from '@/services/Department.service';
import CachedIcon from '@mui/icons-material/Cached';
import URL from '@/common/routes/Url';
import CommonTableContainer from '@/components/common/CommonTableContainer';
import AnnounceTableBody from '@/components/announce/AnnounceTableBody';

interface DelType {
  id: number;
  title: string;
}

const AnnounceList: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [announce, setAnnounce] = useState<Array<Announce & Departments>>([]);
  const [list, setList] = useState<Array<Announce & Departments>>([]);
  const [isloading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [delAnnounce, setDelAnnounce] = useState<DelType>({ id: 0, title: '' });
  const [Departments, setDepartments] = useState<Array<Department>>([]);
  const [departmentName, setDepartmentName] = useState<string>('');

  const getAnnounces = () => {
    AnnounceService.getAll()
      .then((response) => {
        setAnnounce(response.data);
        setList(response.data);
        setIsLoading(false);
      })
      .catch((e) => {
        enqueueSnackbar(Messages.select.failure);
      });
  };

  const gatDepartments = () => {
    DepartmentService.getAll()
      .then((response) => {
        setDepartments(response.data);
      })
      .catch((e) => {
        enqueueSnackbar(Messages.select.failure);
      });
  };

  useLayoutEffect(() => {
    gatDepartments();
    getAnnounces();
  }, []);

  const editAnnounce = (id: number) => {
    navigate(`${URL.announces}/${id}/`);
  };

  const createAnnounce = () => {
    navigate(`${URL.announces}/add`);
  };

  const deleteAnnounce = async (id: number) => {
    setIsLoading(true);
    try {
      await AnnounceService.delete(id);
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message);
      return;
    }

    await AnnounceService.getAll()
      .then((response) => {
        setAnnounce(response.data);
        setList(response.data);
      })
      .catch((e) => {
        enqueueSnackbar(Messages.select.failure);
      });

    setIsLoading(false);
    enqueueSnackbar(Messages.delete.success, { variant: 'info' });
  };

  const handleDialog = (id: number, title: string) => {
    setDelAnnounce({
      id: id,
      title: title,
    });
    setIsOpen(true);
  };

  const handleChangeDepartment = (event: SelectChangeEvent) => {
    setDepartmentName(event.target.value);
  };

  const filtered = () => {
    const filteringList = announce.filter((value, index) => {
      if (!departmentName && value.departments.length === 0) {
        return value;
      }
      const targetDepartments = value.departments.filter((department, index) => {
        return department.name === departmentName;
      });
      return !!targetDepartments.length;
    });
    setList(filteringList);
  };

  const announceTableHeads = ['タイトル', '公開期間', '部署名', ''];
  const styleTableBody = <AnnounceTableBody onEdit={editAnnounce} onDelete={handleDialog} rows={list} />;

  if (isloading) {
    return <Loading />;
  }
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
          <PageTitle>アナウンス</PageTitle>
        </Box>
        <Box sx={{ marginBottom: '8px' }} display="flex" gap={2}>
          <Button variant="contained" color="primary" onClick={() => createAnnounce()}>
            追加画面へ
          </Button>
          <FormControl size="small" style={{ width: '25%', backgroundColor: 'white' }}>
            <InputLabel shrink id="departmentID">
              部署
            </InputLabel>
            <Select
              notched
              labelId="departmentID"
              defaultValue={undefined}
              value={departmentName}
              onChange={handleChangeDepartment}
              id="department"
              label="部署"
              displayEmpty
            >
              <MenuItem key={0} value={''}>
                未設定
              </MenuItem>
              {Departments.map((element) => (
                <MenuItem key={element.id} value={element.name}>
                  {element.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="contained" color="primary" onClick={filtered}>
            絞り込み
          </Button>
          <IconButton
            style={{ float: 'right' }}
            onClick={() => {
              setDepartmentName('');
              setList(announce);
            }}
          >
            <CachedIcon />
            <Box style={{ fontSize: 'small' }}>リセット</Box>
          </IconButton>
        </Box>
        <CommonTableContainer tableHeads={announceTableHeads} tableBody={styleTableBody} />
        <ConfirmDialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          onOk={() => {
            setIsOpen(false);
            deleteAnnounce(delAnnounce.id);
          }}
        >
          {delAnnounce.title}を本当に削除しますか？
        </ConfirmDialog>
      </Grid>
    </Grid>
  );
};
export default AnnounceList;
